import React from "react";
import { Box, IconButton } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import ChartTypeToggle from "../ChartTypeToggle";
import { GraphType } from "@services/monitoring/types";

type ChartActionsProps = {
  chartType?: GraphType;
  onRefresh?: () => void;
  onToggle?: (chartType: GraphType) => void;
};

const ChartActions = (props: ChartActionsProps) => {
  const { chartType, onRefresh, onToggle } = props;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        right: 0,
        display: "flex",
        gap: 1,
        alignItems: "center",
      }}
    >
      {chartType && onToggle && (
        <ChartTypeToggle chartType={chartType} onToggle={onToggle} />
      )}

      {onRefresh && (
        <IconButton onClick={onRefresh}>
          <Refresh />
        </IconButton>
      )}
    </Box>
  );
};

export default ChartActions;
